'use client';

import { useEffect } from 'react';

/**
 * Global Error Boundary (Bypass Mode)
 * Esta tela é a última linha de defesa. 
 * NÃO utiliza componentes externos para evitar erros de referência
 * durante a fase crítica de falha do sistema.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log simplificado para o console do navegador
    if (typeof window !== 'undefined') {
      try {
        console.warn('System Error Captured');
      } catch (e) {
        // Fallback silencioso
      }
    }
  }, [error]);

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: 'sans-serif',
      backgroundColor: '#f8fafc',
      textAlign: 'center',
      color: '#1e293b'
    }}>
      <div style={{
        maxWidth: '450px',
        width: '100%',
        backgroundColor: '#ffffff',
        padding: '40px',
        borderRadius: '16px',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e2e8f0'
      }}>
        <div style={{
          width: '60px',
          height: '60px',
          backgroundColor: '#fee2e2',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px'
        }}>
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        
        <h1 style={{ fontSize: '22px', fontWeight: 'bold', marginBottom: '10px', color: '#0f172a' }}>Sistema Indisponível</h1>
        <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '24px', lineHeight: '1.5' }}>
          Ocorreu uma falha técnica inesperada. O erro foi registrado para análise.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button 
            onClick={() => reset()}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: '#1a237e',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            Tentar Novamente
          </button>
          
          <button 
            onClick={() => { if (typeof window !== 'undefined') window.location.href = '/dashboard'; }}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: 'transparent',
              color: '#1a237e',
              border: '1px solid #1a237e',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            Voltar para o Início
          </button>
        </div>
      </div>
      <p style={{ marginTop: '20px', fontSize: '10px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px' }}>
        Sislog Sabores • Modo de Recuperação
      </p>
    </div>
  );
}
